(function($) {
	$(document).on('mouseup', function(e) {
		const navigation = $('.nav-primary');

		if ( navigation.hasClass('open') && !navigation.is(e.target) && navigation.has(e.target).length === 0) {
			navigation.removeClass('open');
			$('.nav-primary-toggle').removeClass('open');
			$('body').removeClass('overlay-active');
		}

		$('.nav-primary-toggle').on('click', function() {
			$('.nav-primary').toggleClass('open');
			$('body').toggleClass('overlay-active');
			$(this).toggleClass('open');
			$('.toggle-opening-hours').parent().removeClass('open');
		});
	});
})(jQuery);